import { GOAL_IDS, triggerCroConversionGoal } from '@hoc/withCroVariant';
import ContactUsForm from './ContactUsForm';
import React, { useEffect, useState } from 'react';
import { ContactUsFormModalStyles as S } from './ContactUsFormModal.styles';
/**
 * Window event used to show the modal, e.g. from the GF-1284 contact CTA:
 * `window.dispatchEvent(new Event('contactUsFormModal:open'))`
 */
export const CONTACT_US_FORM_MODAL_OPEN_EVENT = 'contactUsFormModal:open';
const ContactUsFormModal = ({ closeText, ...formProps }) => {
    const [isOpen, setIsOpen] = useState(false);
    // The form is only mounted once the modal has been opened, as its beforeunload handler records an
    // abandoned-form activity - otherwise every visitor would be tracked as abandoning it on every page.
    // It stays mounted after closing so anything typed is kept if it's reopened.
    const [hasOpened, setHasOpened] = useState(false);
    // The title is hidden on the confirmation state, which has its own heading
    const [isSubmitted, setIsSubmitted] = useState(false);
    useEffect(() => {
        const open = () => {
            setIsOpen(true);
            setHasOpened(true);
        };
        window.addEventListener(CONTACT_US_FORM_MODAL_OPEN_EVENT, open);
        return () => window.removeEventListener(CONTACT_US_FORM_MODAL_OPEN_EVENT, open);
    }, []);
    return (React.createElement(S.Container, { id: "contact-us-form-modal", "data-open": isOpen, role: "dialog", "aria-labelledby": "contact-us-form-modal-title", "aria-hidden": !isOpen },
        React.createElement(S.CloseButton, { id: "contact-us-form-modal-close", type: "button", "aria-label": closeText, onClick: () => {
                triggerCroConversionGoal(GOAL_IDS.ContactUsFormModal_Close);
                setIsOpen(false);
            } },
            React.createElement(S.CloseIcon, { "aria-hidden": "true" })),
        React.createElement(S.Title, { id: "contact-us-form-modal-title", "data-hidden": isSubmitted }, formProps.title),
        hasOpened && (React.createElement(ContactUsForm, { idPrefix: "contactUsFormModal_", ...formProps, submitButtonId: "contact-us-form-modal-submit", onSuccess: () => {
                triggerCroConversionGoal(GOAL_IDS.ContactUsFormModal_Submit);
                setIsSubmitted(true);
            } }))));
};
export default ContactUsFormModal;
